import React from 'react';
import SelectComponent from "../SelectComponent";
import './style.scss';
import AddCaseComponent from '../AddCaseComponent';


interface Props {
    onChange: (name: string, value: string) => void,
    classification: string,
    classifications: {name: string, id: number}[],
    cases: {name: string, id: number}[],
    caseName: string,
    tags: string,
    comments: string
}


const FormHandleEventsComponent: React.FC<Props> = ({onChange, classification, caseName, tags, comments, classifications, cases}) => {
    const casesArr = [
        {value: '', label: '--CASE--'},
        ...cases.map(({name}) => ({value: name, label: name}))
    ];
    
    return (
        <div className='event-form'>
            <div className='event-form__1row'>
                {
                    classifications.length && <SelectComponent  inputs={classifications.map(({name}) => ({value: name, label: name}))}
                                                                classValue={'event-form__select'}
                                                                title={'Classification'}
                                                                name={'Classification'}
                                                                selected={classification}
                                                                onSubmit={(e) => onChange('classification', e.target.value)}
                    />
                }
            </div>

            <div className='event-form__1row'>
                {
                    <SelectComponent inputs={casesArr}
                                     classValue={'event-form__select'}
                                     title={'Case File'}
                                     name={'caseName'}
                                     selected={'--CASE--'}
                                     onSubmit={(e) => onChange('caseName', e.target.value)}

                    />  
                }
            </div>

            <div className='event-form__1row'>
                    <AddCaseComponent/>
            </div>

            <div className={'event-form__1row'}>
                <div className={'event-form__textarea'}>
                     <input    name='tags'
                               placeholder='Tags'
                               value={tags}
                               onChange={(e) => onChange('tags', e.target.value)} />
                </div>
            </div>

            <div className={'event-form__1row'}>
                <div className={'event-form__textarea'}>
                    <textarea  value={comments}
                               placeholder='Comments'
                               onChange={(e) => onChange('comments', e.target.value)} />
                </div>
            </div>
        </div>
    );
};

export default FormHandleEventsComponent;